import moment from "moment";

const ActualTime = (value: string) => {
    if (value.includes('GMT')) {
        const d = new Date(value);
        value = moment(value).subtract(d?.getTimezoneOffset() * -1, 'minutes')?.toString();
        return value
    }
    else {
        return value
    }
}

export default ActualTime;

export const ActualDate = (value: string) => {
    // const d = new Date(value);
    // if (value.includes('Z') || value.includes('z')) {
    //     value = moment(value).subtract(d?.getTimezoneOffset() * -1, 'minutes')?.toString();
    // }
    return value;
}   